import { ref, watch } from 'vue';
import { useImage } from '@vueuse/core';

export function useCachedImage(source, options = {}) {
    const isCached = ref(false);

    watch(source, (s) => {
        if (!s?.src) { isCached.value = false; return; }
        const img = new Image();
        img.src = s.src;
        isCached.value = img.complete;
    });

    return { ...useImage(source, options), isCached };
}
